<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Sample Set', apiMethod: 'SampleSets', form: () => import('../forms/SampleSetForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Sample Set Sample', apiMethod: 'SampleSetSamples', parentForeignKey: 'sampleSetId', form: () => import('../forms/SampleSetSampleForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Sample Set Test', apiMethod: 'SampleSetTests', parentForeignKey: 'sampleSetId', form: () => import('../forms/SampleSetTestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Samples', value: 'sampleSetId', isCard: true, table: () => import('../tables/SampleSetSamplesTable') },
                    { text: 'Tests', value: 'sampleSetId', isCard: true, table: () => import('../tables/SampleSetTestsTable') },
                ],
                mainForm: () => import('../forms/SampleSetForm'),
                claimName: 'SampleSets',
                apiMethod: 'SampleSets',
            }
        }
    };
</script>
